export default class ChartController {
    static $inject = ['$scope','$element','$compile'];
    constructor($scope, $element, $compile) {
        'ngInject';
        this.$scope = $scope;
        this.$element = $element;
        this.$compile = $compile;
        this.options = {
            responsive: false,
            maintainAspectRatio: false,
            scaleShowGridLines: true,
            scaleGridLineColor: "rgba(0,0,0,.05)",
            scaleGridLineWidth: 1,
            bezierCurve: true,
            bezierCurveTension: 1,
            pointDot: true,
            pointDotRadius: 5,
            pointDotStrokeWidth: 1,
            pointHitDetectionRadius: 20,
            datasetStroke: true,
            datasetStrokeWidth: 3,
            datasetFill: false,
            barShowStroke : false,
            scales: {
                yAxes: [{
                    stacked: true,
                    scaleLabel: {
                        display: true,
                        labelString: this.ylabel
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }],
                xAxes: [{
                    stacked: true,
                    barPercentage: this.getBarWidth(this.data ? this.data.labels.length : 0),
                    categoryPercentage: 0.001,
                    scaleLabel: {
                        display: true,
                        labelString: this.xlabel
                    },
                    gridLines: {
                        display: false
                    }
                }]
            },
            legend: {
                display: false,
                position: 'right',
                onClick: function (e, item) {
                    const chart = this.chart;
                    this.chart.data.datasets.forEach((d, i) => {
                        if (d.stack === item.text) {
                            const meta = chart.getDatasetMeta(i);
                            meta.hidden = !meta.hidden;
                            item.hidden = meta.hidden;
                            item.hidden = !chart.isDatasetVisible(i);
                        }
                    });
                    chart.update();
                },
                labels: {
                    boxWidth: 0,
                    generateLabels: chart => {
                        return this.data.override.map((o, i) => ({
                            text: o.stack,
                            fillStyle: `rgba(${o.color.r}, ${o.color.g}, ${o.color.b}, 0.6)`,
                            strokeStyle: `rgba(${o.color.r}, ${o.color.g}, ${o.color.b}, 0.8)`,
                            hidden: !chart.isDatasetVisible(i)
                        })).reduce((acc, val) => {
                            if (!acc.some(a => a.text === val.text)) {
                                return [...acc, val];
                            }
                            return acc;
                        }, []);
                    }
                }
            },
            tooltips: {
                intersect: false,
                position: 'average',
                mode: 'point',
                filter: function(item, data) {
                    return item.xLabel === data.datasets[item.datasetIndex].stack;
                },
                callbacks: {
                    label: function(item, data) {
                        return `${data.datasets[item.datasetIndex].serie}: ${item.yLabel}`;
                    }
                }
            },
            title: {
                display: true,
                text: this.title,
                lineHeight: '1'
            },
            legendCallback: chart => {
                const list = this.data.override.map((o, i) => {
                    if (this.excludedItems.indexOf(o.stack) !== -1) {
                        const meta = chart.getDatasetMeta(i);
                        meta.hidden = true;
                    }

                    return {
                        text: o.stack,
                        fillStyle: `rgba(${o.color.r}, ${o.color.g}, ${o.color.b}, 0.6)`,
                        strokeStyle: `rgba(${o.color.r}, ${o.color.g}, ${o.color.b}, 0.8)`,
                        hidden: !chart.isDatasetVisible(i)
                    };
                }).reduce((acc, val) => {
                    if (!acc.some(a => a.text === val.text)) {
                        return [...acc, val];
                    }
                    return acc;
                }, []);
                chart.update();

                const lis = list.map((d, index) => `<li ${d.hidden ? 'class="removed"' : ''} data-item="${d.text}" data-ng-click="$ctrl.onLegendItemClick($event, '${d.text}')" title="${d.text}"><span style="border-color: ${d.strokeStyle}; background-color: ${d.strokeStyle}"></span> ${d.text}</li>`);
                return `<ul>${lis.join('')}</ul>`;
            }
        };
    }

    $onInit() {
        this.calculateStyles(this.height);
        this.unwatchDataLength = this.$scope.$watch(() => this.data ? this.data.labels.length : 0, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.options.scales.xAxes[0].barPercentage = this.getBarWidth(newValue);
            }
        })
        this.unwatchHeight = this.$scope.$watch(() => this.height, (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.calculateStyles(newValue);
            }
        });
        this.unwatchTitle = this.$scope.$watch(() => this.title, (newValue, oldValue) => {
            this.options.title.text = newValue;
        });
        this.cancelCreate = this.$scope.$on('chart-create', (e, chart) => {
            this.chart = chart;
            const legend = this.$compile(chart.generateLegend())(this.$scope);
            this.$element.find('.legend-container').html(legend);
        });
        this.autoResize();
    }

    getBarWidth(dataLength) {
        return 600 * dataLength;
    }

    $onDestroy() {
        this.unwatchDataLength();
        this.unwatchHeight();
        this.unwatchTitle();
        this.cancelCreate();
    }

    calculateStyles(height) {
        this.wrapperStyle = { 'max-height': `${height}px` };
        this.boxStyle = { height: `${height - 30}px` };
        this.legendStyle = { height: `${height - 70}px` };
    }

    onLegendItemClick(e, stack) {
        const target = e.target.nodeName === 'LI' ? e.target : e.target.parentNode;
        this.chart.data.datasets.forEach((d, i) => {
            if (d.stack === stack) {
                const meta = this.chart.getDatasetMeta(i);
                meta.hidden = !meta.hidden;
                if (meta.hidden) {
                    target.classList.add('removed');
                } else {
                    target.classList.remove('removed');
                }
            }
        });
        this.onLegendItemToggle(target.dataset.item);
        this.chart.update();
    }



    autoResize() {
        const canvas = document.getElementById('chart');
        const context = canvas.getContext('2d');

        // resize the canvas to fill browser window dynamically
        window.addEventListener('resize', resizeCanvas, false);

        function resizeCanvas() {
            canvas.width = window.innerWidth/2;
            canvas.height = window.innerHeight/2;
            /**
             * Your drawings need to be inside this function otherwise they will be reset when
             * you resize the browser window and the canvas goes will be cleared.
             */
            drawStuff();
        }

        resizeCanvas();

        function drawStuff() {
            // do your drawing stuff here
           // console.log('drawStuff')
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/chart/chart.controller.js